
import {
  FETCH_PLAYLIST_SUCCESS,
  FETCH_USER_PLAYLIST_SUCCESS,
  FETCH_CURRENT_PLAYLIST_SUCCESS,
  // FETCH_DISCOVER_PLAYLIST_SUCCESS,
  STORE_HISTORY
} from '../actions/playlistActions';

const initialState = {
  playlist: [],
  userPlaylist: [],
  history: null,
  currentPlaylist:[],
  // discover: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case STORE_HISTORY:
      return {
        ...state,
        history: action.history.historyy
      }

    case FETCH_PLAYLIST_SUCCESS:
      return {
        ...state,
        playlist: action.payload.playlist
      };

    case FETCH_USER_PLAYLIST_SUCCESS:
      return {
        ...state,
        userPlaylist: action.payload.playlists.filter((list) =>
          list.type == "playlist-list" && list.heading == "Collections"
        ),
      };

      case FETCH_CURRENT_PLAYLIST_SUCCESS:
        return {
          ...state,
            currentPlaylist: action.payload.playlistdd,
        };

    // case FETCH_DISCOVER_PLAYLIST_SUCCESS:
    //   return {
    //     ...state,
    //     discover: action.payload.playlistsd.filter((list) => 
    //     !list.name.includes("Portrait")
    //     ),
    //   };

    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
}